import { cn } from '@/lib/utils'

interface ExpirationBadgeProps {
  count: number
  daysUntilExpiry: number
}

export function ExpirationBadge({
  count,
  daysUntilExpiry,
}: ExpirationBadgeProps) {
  // Determinar el color según los días hasta vencimiento
  const getColorClasses = () => {
    if (daysUntilExpiry < 0) {
      // Vencido - rojo personalizado
      return 'text-[#991B1B]'
    } else if (daysUntilExpiry <= 7) {
      // Vence en 7 días o menos - rojo personalizado
      return 'text-[#991B1B]'
    } else if (daysUntilExpiry <= 30) {
      // Vence en 30 días o menos - amarillo personalizado
      return 'text-[#713F12]'
    } else {
      // Más de 30 días - verde personalizado
      return 'text-[#166534]'
    }
  }

  const getBackgroundClasses = () => {
    if (daysUntilExpiry < 0) {
      // Vencido - fondo rojo personalizado
      return 'bg-[#FECACA]'
    } else if (daysUntilExpiry <= 7) {
      // Vence en 7 días o menos - fondo rojo personalizado
      return 'bg-[#FECACA]'
    } else if (daysUntilExpiry <= 30) {
      // Vence en 30 días o menos - fondo amarillo personalizado
      return 'bg-[#FEF9C3]'
    } else {
      // Más de 30 días - fondo verde personalizado
      return 'bg-[#BBF7D0]'
    }
  }

  const colorClasses = getColorClasses()
  const backgroundClasses = getBackgroundClasses()

  return (
    <div
      className={cn(
        'inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold',
        backgroundClasses,
        colorClasses
      )}
    >
      {count}
    </div>
  )
}
